/**
 * 检测IE是否安装了PDF插件
 */
export default function hasPdfReader() {
    return function () {
        if (!(window.ActiveXObject || 'ActiveXObject' in window)) return true

        function createAXO(type) {
            let ax
            try {
                ax = new ActiveXObject(type)
            } catch (e) {
                ax = null // ensure ax remains null
            }
            return ax
        }
        if (createAXO('AcroPDF.PDF') || createAXO('PDF.PdfCtrl')) return true
    }
}



// WEBPACK FOOTER //
// ./src/common/services/hasPDFReader.js